import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  Table,
  Button,
  Space,
  Input,
  Select,
  Typography,
  Popconfirm,
  Empty,
  Divider,
} from 'antd';
import {
  PlusOutlined,
  SaveOutlined,
  RollbackOutlined,
  ZoomInOutlined,
} from '@ant-design/icons';

import {
  selectors,
  getMacroBackgrounds,
  MacroBackgroundType,
  createMacroBackgroundAdmin,
  AdminETFDetailsTable,
  deleteMacroBackground,
  requestIndexFundPreview,
  updateMacroBackgroundAdmin,
  duplicateMacroBackground,
} from 'state';

import EditableTable from './EditableTable';
import { useModal } from 'services';
import CreatePresetModal from './CreatePresetModal';
import CreateMacroBackgroundModal from './CreateMacroBackgroundModal';
import EditPresetNameModal from './EditPresetNameModal';
import EditMacroBackgroundNameModal from './EditMacroBackgroundNameModal';

const { TextArea } = Input;

const MacroBackgroundTab: React.FC = () => {
  const dispatch = useDispatch();
  const macros = useSelector(selectors.macroBackgrounds);
  const waiting = useSelector(selectors.macroBackgroundsWaiting);
  const [CreateModal, showCreateModal] = useModal(CreateMacroBackgroundModal);

  useEffect(() => {
    if (Object.values(macros).length === 0) dispatch(getMacroBackgrounds({}));
  }, [dispatch]);

  useEffect(() => {
    if (presetId && !macros[presetId]) {
      const all = Object.values(macros);
      const last = all[all.length - 1];
      if (last) {
        setPresetId(last.id);
        setBody(last.body || '');
        setName(last.name || '');
      } else {
        // prevents random numbers showing in Select if user just deleted last preset
        // no presets left
        setPresetId(undefined);
        setBody('');
        setName('');
      }
    }

    const all = Object.values(macros);
    const last = all[all.length - 1];
    if (last) {
      console.log('entered last');
      setPresetId(last.id);
      setBody(last.body || '');
      setName(last.name || '');
    }
  }, [Object.values(macros).length]);

  const noData = (
    <Empty
      description={
        <Typography.Text type={'secondary'}>
          Select a preset or create one
        </Typography.Text>
      }
    />
  );

  const noDataBehaviour = {
    emptyText: noData,
  };

  const columns = {
    id: {
      // title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 40,
    },
    name: {
      // title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    body: {
      // title: 'Body',
      dataIndex: 'body',
      key: 'body',
      // width: '1400px',
      width: '55vw',
      render(value: any) {
        return (
          <div
            // style={
            //   {
            //     // color: 'red',
            //     // wordWrap: 'initial',
            //     // whiteSpace: 'initial',
            //   }
            // }
            style={{
              whiteSpace: 'pre-wrap', // preserves \n and wraps long lines
              wordBreak: 'break-word', // avoid horizontal scroll
            }}
          >
            {value}
          </div>
        );
      },
      onCell: () => ({
        style: {
          // maxHeight:
          whiteSpace: 'normal',
          wordBreak: 'break-word',
        },
      }),
    },
  };

  const [presetId, setPresetId] = useState<number | undefined>(undefined);
  const [body, setBody] = useState<string>('');
  const [name, setName] = useState<string>('');

  const [EditNameModal, showEditNameModal] = useModal(
    EditMacroBackgroundNameModal
  );

  return (
    // <Space direction={'vertical'}>
    <Space direction={'vertical'}>
      <Space direction={'horizontal'}>
        <Button onClick={() => showCreateModal({})} style={{ marginBottom: 0 }}>
          Create New
        </Button>
        <Typography.Title level={3} style={{ marginTop: 8 }}>
          {' '}
          |{' '}
        </Typography.Title>
        {/*<Divider type={'vertical'} />*/}
        <Select
          // noDataBehaviour={noDataBehaviour}
          loading={waiting}
          value={presetId ?? undefined} // control the value
          showSearch
          allowClear
          style={{ width: 250, marginTop: 0 }}
          // placeholder="Select Preset"
          placeholder={waiting ? 'Loading...' : 'Select a preset to see/edit'}
          optionFilterProp="children"
          onChange={value => {
            if (value === undefined) {
              // user cleared selection
              setPresetId(undefined);
              setBody('');
              setName('');
              return;
            }
            const id = value as number; // don't Number(undefined)
            setPresetId(id);
            setBody(macros[id]?.body || '');
            setName(macros[id]?.name || '');
          }}
        >
          {Object.values(macros)
            .sort((a, b) => b.id - a.id)
            .map(({ id, name }) => (
              <Select.Option key={id} value={id}>
                {name}
              </Select.Option>
            ))}
        </Select>
        {presetId && (
          <>
            <Popconfirm
              title={'Delete?'}
              onConfirm={() =>
                dispatch(deleteMacroBackground({ id: presetId }))
              }
            >
              <Button>Delete</Button>
            </Popconfirm>
            <Button
              onClick={() =>
                dispatch(duplicateMacroBackground({ id: presetId }))
              }
            >
              Duplicate
            </Button>
            <Button
              onClick={() => {
                if (presetId) {
                  showEditNameModal({
                    preset_id: presetId,
                    preset_name: name,
                  });
                }
              }}
            >
              Rename
            </Button>
            <Button
              onClick={() => {
                console.log(presetId);
                if (presetId) {
                  dispatch(
                    updateMacroBackgroundAdmin({
                      id: presetId,
                      body: body,
                    })
                  );
                }
              }}
            >
              Save Body
            </Button>
          </>
        )}
      </Space>
      <TextArea
        value={body}
        style={{ height: '70vh', marginTop: 10, width: 900 }}
        onChange={e => {
          setBody(e.target.value);
        }}
      />
      {CreateModal}
      {EditNameModal}
      {/*</Space>*/}
    </Space>
  );
};

export default MacroBackgroundTab;
